<template>
  <span class="reading-type-container">
    <span 
      :class="['reading-type-badge', badgeClass]"
      :title="tooltipTitle"
    >
      {{ displayCode }}
    </span>
    <span 
      v-if="showTooltip"
      v-b-popover.hover.right.html="tooltipContent"
      :title="tooltipTitle"
      class="ml-1 pointer"
    >
      <i class="fa fa-question-circle" aria-hidden="true"></i>
    </span>
  </span>
</template>

<script>
export default {
  name: 'ReadingTypeIcon',
  
  props: {
    value: {
      type: String,
      required: true
    },
    row: {
      type: Object,
      default: () => ({})
    },
    showTooltip: {
      type: Boolean,
      default: true
    },
    tooltipContent: {
      type: String,
      default: `
        <div><b>A</b> - Actual Reading</div><br>
        <div><b>C</b> - Customer Reading</div><br>
        <div><b>E</b> - Estimated Reading</div><br>
        <div><b>D</b> - Deemed Reading</div>
      `
    },
    readingTypeMap: {
      type: Object,
      default: () => ({
        'ActualFromIndustry': { code: 'A', label: 'Actual Reading', variant: 'success' },
        'Actual': { code: 'A', label: 'Actual Reading', variant: 'success' },
        'Customer': { code: 'C', label: 'Customer Reading', variant: 'primary' },
        'ChangeOfTenancy': { code: 'C', label: 'Change of Tenancy', variant: 'primary' },
        'EstimatedFromIndustry': { code: 'E', label: 'Estimated Reading', variant: 'warning' },
        'Estimate': { code: 'E', label: 'Estimated Reading', variant: 'warning' },
        'Deemed': { code: 'D', label: 'Deemed Reading', variant: 'info' },
        'Initial': { code: 'I', label: 'Initial Reading', variant: 'secondary' },
        'Final': { code: 'F', label: 'Final Reading', variant: 'secondary' }
      })
    }
  },

  computed: {
    readingConfig() {
      // Handle variations in reading type names
      const type = this.value
      
      // Direct match first
      if (this.readingTypeMap[type]) {
        return this.readingTypeMap[type]
      }
      
      // Check for partial matches
      if (type && type.includes && type.includes('Estimate')) {
        return this.readingTypeMap['Estimate']
      }
      
      // Default fallback
      return { 
        code: type ? type.charAt(0).toUpperCase() : '?', 
        label: type || 'Unknown', 
        variant: 'secondary' 
      }
    },

    displayCode() {
      return this.readingConfig.code
    },

    badgeClass() {
      return `badge-${this.readingConfig.variant}`
    },

    tooltipTitle() {
      return `Reading Type: ${this.readingConfig.label}`
    }
  }
}
</script>

<style scoped>
.reading-type-container {
  display: inline-flex;
  align-items: center;
}

.reading-type-badge {
  display: inline-block;
  padding: 0.25em 0.5em;
  font-size: 0.85em;
  font-weight: bold;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.375rem;
  min-width: 1.5rem;
}

.badge-primary {
  color: #fff;
  background-color: #007bff;
}

.badge-success {
  color: #fff;
  background-color: #28a745;
}

.badge-warning {
  color: #212529;
  background-color: #ffc107;
}

.badge-info {
  color: #fff;
  background-color: #17a2b8;
}

.badge-secondary {
  color: #fff;
  background-color: #6c757d;
}

.pointer {
  cursor: pointer;
}

.fa-question-circle {
  color: #6c757d;
  font-size: 0.9em;
}
</style>